import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { hexToHsl } from "@/lib/media";

const SiteCtx = createContext(null);

function detectPreview() {
  if (typeof window === "undefined") return false;
  const qs = new URLSearchParams(window.location.search);
  if (qs.get("preview") === "1") {
    sessionStorage.setItem("influcas_preview", "1");
    return true;
  }
  if (qs.get("preview") === "0") {
    sessionStorage.removeItem("influcas_preview");
    return false;
  }
  return sessionStorage.getItem("influcas_preview") === "1";
}

export function SiteProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [isPreview] = useState(detectPreview());

  useEffect(() => {
    api.get("/site-config").then(setConfig).catch(() => setConfig({}));
  }, []);

  useEffect(() => {
    if (!config) return;
    const root = document.documentElement;
    const p = hexToHsl(config.primary_color);
    const s = hexToHsl(config.secondary_color);
    if (p) root.style.setProperty("--primary", p);
    if (s) root.style.setProperty("--accent", s);
    if (config.favicon) {
      const link = document.querySelector("link[rel='icon']") || document.createElement("link");
      link.rel = "icon";
      link.href = config.favicon.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL || ""}${config.favicon}` : config.favicon;
      document.head.appendChild(link);
    }
    if (config.site_name) document.title = config.site_name;
  }, [config]);

  // Helper: respects nav visibility unless preview
  const showSection = (key) => isPreview || config?.[key] !== false;

  return <SiteCtx.Provider value={{ config, setConfig, isPreview, showSection }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
